import React, { useState } from 'react';
import Button from '../../global/Button';
import Button2 from '../../global/Button2';
import { TDirectorInfo } from '../../../types';
import ShareholderDocInputs from './ShareholderDocInputs';
import { encryptData } from '../../../utils/encryptJson';
import AddressSavedModal from '../BusinessAddres/AddressSavedModal';

type TProps = {
  shareholders: TDirectorInfo[];
  currentShareholder: number;
  setActiveStage: React.Dispatch<React.SetStateAction<number>>;
  activeStage: number;
  setShareholders: React.Dispatch<React.SetStateAction<TDirectorInfo[]>>;
  isStageThreeComplete: boolean;
  director?: boolean;
};

const DocumentUpload = ({
  currentShareholder,
  isStageThreeComplete,
  setActiveStage,
  setShareholders,
  shareholders,
  director = false,
}: TProps) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className='mr-[4vw] h-[100%]'>
      <div>
        <div className='sl:flex w-full sl:gap-[5%]'>
          <div className='sl:w-[45%] mb-4'>
            <div className='w-[full]'>
              <ShareholderDocInputs
                value={shareholders?.[currentShareholder]?.passport}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const shareholders_ = shareholders?.[currentShareholder]
                    ? shareholders
                    : [...shareholders, {} as TDirectorInfo];
                  const shareholder = shareholders_?.map((shareholder, ind) => {
                    if (currentShareholder === ind) {
                      return {
                        ...shareholder,
                        passport: e?.target?.files?.[0],
                      };
                    }
                    return shareholder;
                  });
                  setShareholders(shareholder);
                }}
                label='Passport Photograph'
              />
            </div>
          </div>
          <div className='sl:w-[45%] mb-4'>
            <div className='w-[full]'>
              <ShareholderDocInputs
                value={shareholders?.[currentShareholder]?.proofOfAddress}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const shareholders_ = shareholders?.[currentShareholder]
                    ? shareholders
                    : [...shareholders, {} as TDirectorInfo];
                  const shareholder = shareholders_?.map((shareholder, ind) => {
                    if (currentShareholder === ind) {
                      return {
                        ...shareholder,
                        proofOfAddress: e?.target?.files?.[0],
                      };
                    }
                    return shareholder;
                  });
                  setShareholders(shareholder);
                }}
                label='Proof of Address'
              />
            </div>
          </div>
        </div>

        <div className='sl:flex w-full sl:gap-[5%]'>
          <div className='sl:w-[45%] mb-4'>
            <div className='w-[full]'>
              <ShareholderDocInputs
                value={shareholders?.[currentShareholder]?.idCard}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const shareholders_ = shareholders?.[currentShareholder]
                    ? shareholders
                    : [...shareholders, {} as TDirectorInfo];
                  const shareholder = shareholders_?.map((shareholder, ind) => {
                    if (currentShareholder === ind) {
                      return {
                        ...shareholder,
                        idCard: e?.target?.files?.[0],
                      };
                    }
                    return shareholder;
                  });
                  setShareholders(shareholder);
                }}
                label='Valid ID Card'
              />
            </div>
          </div>
          <div className='sl:w-[45%] mb-4'>
            <div className='w-[full]'>
              <ShareholderDocInputs
                value={shareholders?.[currentShareholder]?.signature}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const shareholders_ = shareholders?.[currentShareholder]
                    ? shareholders
                    : [...shareholders, {} as TDirectorInfo];
                  const shareholder = shareholders_?.map((shareholder, ind) => {
                    if (currentShareholder === ind) {
                      return {
                        ...shareholder,
                        signature: e?.target?.files?.[0],
                      };
                    }
                    return shareholder;
                  });
                  setShareholders(shareholder);
                }}
                label='Signature'
              />
            </div>
          </div>
        </div>
      </div>

      <div className='flex justify-between my-[65px]'>
        <Button
          className='px-2 md:px-5 !py-[10px] !bg-[#768396] text-[11px] text-white border-[0px] rounded-none '
          size='sm'
          underline={false}
          theme='secondary'
          onClick={() => setActiveStage((prev) => prev - 1)}
        >
          PREVIOUS
        </Button>
        <Button2
          className='px-2 md:px-5 !py-[10px] text-[11px] text-white border-[0px] rounded-none '
          size='sm'
          underline={false}
          theme='primary'
          disabled={!isStageThreeComplete}
          onClick={() => setShowModal(true)}
        >
          SAVE
        </Button2>
      </div>
      {/* ${shareholders?.[currentShareholder]?.firstName + ' ' + shareholders?.[currentShareholder]?.lastName} */}
      <AddressSavedModal
        setShowSuccessModal={setShowModal}
        showSuccessModal={showModal}
        description={` Trustee ${currentShareholder + 1} ${
          currentShareholder + 1 === 1
            ? '(Chairman)'
            : currentShareholder + 1 === 2
            ? '(Secretary)'
            : '(Memeber)'
        } is successfully Added!`}
        handleClick={() => {
          setShowModal(false);
          setActiveStage((prev) => prev + 1);
        }}
        bottomText={`PROCEED`}
      />
    </div>
  );
};

export default DocumentUpload;
